import React, { useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import OrderDetails from "../OrderDetails";
import Breadcrumbs from "../../../../components/Checkout/Breadcrumbs/BreadCrumbs";
import { HelmetProvider } from "react-helmet-async";
import MetaTags from "../../../../components/MetaTags";
import useExperienceData from "../../../../hooks/useExperienceData";
import useCheckoutContext from "../../../../hooks/useExperienceCheckout";
import MercadoPago from "../../../Checkout/Components/payments/MercadoPago";

const Payments = () => {
    const currentStep = 2;

    const [loading] = useState(false);

    // Get order from checkout context
    const { order, loading: orderLoading } = useCheckoutContext();
    const { experience, promoter } = useExperienceData();


    if (loading || orderLoading || !experience || !promoter || !order) return <Loader />;
    console.log(order);

    const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <MetaTags
                name={promoter?.fullname || ""}
                icon={promoter?.logoURL || ""}
                url={currentUrl}
                font={experience.font ? experience.font : null}
                primaryColor={experience.colors.primary_color ? experience.colors.primary_color : null}
                secondaryColor={experience.colors.secondary_color ? experience.colors.secondary_color : null}
            />
            <Header loading={false} promoter={promoter} stock={Infinity} error={null}></Header>
            <div className="payments__container">
                <Breadcrumbs currentStep={currentStep} orderStatus={null} noGoBack={true}></Breadcrumbs>
                <div className="main-content">
                    <div className="payments-details__container">
                        <MercadoPago order={order} isExtenalProduct={true} />
                    </div>
                    <OrderDetails
                        handleCheckboxChange={() => { alert("Not implemented") }}
                        handleSubmitNextStep={() => { alert("Not implemented") }}
                        isFormValid={true}
                        nextStepLabel={"Siguiente paso"}
                    />
                </div>
            </div>
            <Footer loading={false} promoter={promoter}></Footer>
        </HelmetProvider>
    );
};

export default Payments;
